import { type FC } from 'react';

import { Heading, Text } from '../Typography';
import {
  amountStyles,
  cardStyles,
  changeButtonStyles,
  dividerStyles,
  footnoteStyles,
  headerStyles,
  listStyles,
  rowStyles,
  titleBlockStyles,
  totalRowStyles,
} from './MembershipSummaryCard.styles';
import { type MembershipSummaryCardProps } from './MembershipSummaryCard.types';

const textColor = 'var(--color-primary-800)';
const mutedColor = 'var(--color-hunter-400)';

const MembershipSummaryCard: FC<MembershipSummaryCardProps> = ({
  title,
  subtitle,
  onChange,
  changeLabel = 'Change',
  lineItems,
  total,
  footnote,
  className,
  ...rest
}) => {
  return (
    <section css={cardStyles} className={className} {...rest}>
      <header css={headerStyles}>
        <div css={titleBlockStyles}>
          <Heading as="h2" size="2xs" fontWeight="bold" color={textColor}>
            {title}
          </Heading>
          <Text as="p" size="sm" color={mutedColor}>
            {subtitle}
          </Text>
        </div>

        {onChange ? (
          <button type="button" css={changeButtonStyles} onClick={onChange}>
            <Text as="span" size="md" color="inherit">
              {changeLabel}
            </Text>
          </button>
        ) : null}
      </header>

      <hr css={dividerStyles} />

      <dl css={listStyles}>
        {lineItems.map((item, index) => (
          <div key={`${item.label}-${index}`} css={rowStyles}>
            <dt>
              <Text as="span" size="md" color={textColor}>
                {item.label}
              </Text>
            </dt>
            <dd css={amountStyles}>
              <Text as="span" size="md" color={textColor} textAlign="right">
                {item.amount}
              </Text>
            </dd>
          </div>
        ))}

        <div css={[rowStyles, lineItems.length > 0 && totalRowStyles]}>
          <dt>
            <Heading as="p" size="2xs" fontWeight="bold" color={textColor}>
              {total.label}
            </Heading>
          </dt>
          <dd css={amountStyles}>
            <Heading
              as="p"
              size="2xs"
              fontWeight="bold"
              color={textColor}
              textAlign="right"
            >
              {total.amount}
            </Heading>
          </dd>
        </div>
      </dl>

      {footnote ? (
        <Text as="p" size="sm" color={mutedColor} css={footnoteStyles}>
          {footnote}
        </Text>
      ) : null}
    </section>
  );
};

MembershipSummaryCard.displayName = 'MembershipSummaryCard';

export default MembershipSummaryCard;
